<template>
  <div v-if="isPreEvent || isAlwaysShown" id="registerNowWrapper">
    <RegisterNow :sold-out="soldOut" :for-event="forEvent" :label="label" />
  </div>
</template>

<script setup>
import RegisterNow from "@/components/CallToAction/RegisterNow.vue";
import useEventState from "@/composables/useEventState";
// isAlwaysShown: also outside the in-person pre-event period (e.g. for VIZBI Online);
// forEvent, label: as RegisterNow's (e.g. /2026: the event left, "Complete Registration")
const props = defineProps({ // eslint-disable-line
  soldOut: Boolean,
  isAlwaysShown: Boolean,
  forEvent: {type: String, default: undefined},
  label: {type: String, default: "Register Now"}
});
const {isPreEvent} = useEventState();
</script>

<style scoped>
#registerNowWrapper {
  position: relative;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.75rem;
}
.narrow #registerNowWrapper {
  font-size: 1.2rem;
}
</style>
